import { render, staticRenderFns } from "./OldmanBirthday.vue?vue&type=template&id=2fa4f498&scoped=true"
import script from "./OldmanBirthday.vue?vue&type=script&lang=js"
export * from "./OldmanBirthday.vue?vue&type=script&lang=js"
import style0 from "./OldmanBirthday.vue?vue&type=style&index=0&id=2fa4f498&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa4f498",
  null
  
)

export default component.exports